import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import * as Styles from "./Empfehlung.styles";
import MainHeader from "components/Wrapper/HealthAnalyseHeader";
import ApiCollections from "configs/services/apiCollections";
import { useSelector } from "react-redux";

const Empfehlung = () => {
  const history = useHistory();
  const { registrationData } = useSelector((state) => state.auth);
  const [isMobile, setIsMobile] = useState(false);

  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const handleBtnClick = (url) => {
    window.open("https://my.foodiary.app/", "_self");
  };
  const handleResize = () => {
    if (window.innerWidth < 900) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };
  useEffect(() => {
    document.body.classList.add("app-register");
    if (window.innerWidth < 600) {
      setIsMobile(true);
    }
    window.addEventListener("resize", handleResize);
    return () => {
      document.body.classList.remove("app-register");
    };
  }, []);

  useEffect(() => {
    const data = {
      trainer_id: registrationData?.trainerID,
    };
    setIsLoading(true);
    ApiCollections.getProductsjp(data)
      .then((res) => {
        setProducts(res.getAllProductsJpByTrainerId);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log("🚀 ~ err:", err);
        setIsLoading(false);
      });
  }, []);

  return (
    <Styles.Container>
      <div className="main-div">
        <MainHeader
          headline={"Verbessere deine Gesundheit"}
          subHeadline={"Möchtest du gesund Durchstarten?"}
          handleNextPage={handleBtnClick}
          btnText={"Abschließen"}
          noBackButton={true}
        />
        <Styles.ContentSection>
          <Styles.IntroText>
            Optimiere deine Erfolge und verbessere deine Gesundheit mit der
            richtigen Portion an Vitaminen, Mineralstoffen und Spurenelementen.
          </Styles.IntroText>

          <Styles.ProductGrid>
            {isLoading ? (
              <div style={{ textAlign: "center", padding: "30px 0" }}>
                <p>Produkte werden geladen...</p>
              </div>
            ) : products.length === 0 ? (
              <div style={{ textAlign: "center", padding: "30px 0" }}>
                <p>Keine Produkte gefunden.</p>
              </div>
            ) : (
              products.map((product) => (
                <Styles.ProductCard
                  key={product.id}
                  onClick={() =>
                    window.open(product.product_jp_shoppingcart, "_blank")
                  }
                >
                  <Styles.ProductImageContainer>
                    <Styles.ProductImage
                      src={product.product_jp_img}
                      alt={product.product_jp_name}
                    />
                  </Styles.ProductImageContainer>
                  <Styles.ProductInfo>
                    <Styles.ProductBrand>
                      {product.product_jp_company}
                    </Styles.ProductBrand>
                    <Styles.ProductName>
                      {product.product_jp_name}
                    </Styles.ProductName>
                    {product.product_jp_description && (
                      <Styles.ProductDescription>
                        {product.product_jp_description.length > 80
                          ? `${product.product_jp_description.substring(
                              0,
                              isMobile ? 30 : 80
                            )}...`
                          : product.product_jp_description}
                      </Styles.ProductDescription>
                    )}
                    <Styles.ActionButton>
                      Gesundheit optimieren
                    </Styles.ActionButton>
                  </Styles.ProductInfo>
                </Styles.ProductCard>
              ))
            )}
          </Styles.ProductGrid>
        </Styles.ContentSection>
      </div>
      <button
        onClick={handleBtnClick}
        className="btn-dark w-full mt-8 btn-show"
      >
        Weiter
      </button>
    </Styles.Container>
  );
};

export default Empfehlung;
